import { useReactiveVar } from '@apollo/client'
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Divider, Typography } from '@mui/material'
import { modalVar } from '../../../../../providers/apollo/cache'

export default function DisconnectWhatsAppAccount() {
  const modal = useReactiveVar(modalVar)
  const open = modal === 'integrationDisconnectGroupWhatsApp'
  const onClose = () => {
    modalVar(null)
  }
  const onDisconnect = () => {}

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" sx={{ borderRadius: '8px', marginLeft: 'auto', marginRight: 'auto' }}>
      <DialogTitle textAlign="center" fontWeight={800} fontSize={16}>
        Disconnect this Group?{' '}
      </DialogTitle>
      <DialogContent>
        <Typography textAlign="center" variant="body1" fontWeight={400} fontSize={16} letterSpacing={0}>
          This action will unlink this Group Chat from the associated Bucket. We will no longer save photos or videos that are shared in the Group
          Chat. Would you like to continue?
        </Typography>
      </DialogContent>
      <Divider sx={{ bgcolor: '#DFDFDF' }} />
      <DialogActions sx={{ paddingTop: '12px', paddingBottom: '12px', justifyContent: 'center' }}>
        <Box display="flex" justifyContent="flex-end" gap={2} width="100%">
          <Button
            variant="outlined"
            onClick={onClose}
            sx={{
              color: '#1C47CB',
              borderColor: '#1C47CB',
              fontWeight: 600,
              fontSize: '14px',
              borderRadius: '80px',
              textTransform: 'none',
              '&:root': {
                minHeight: 0,
                minWidth: 0
              },
              '&:hover': {
                borderColor: '#1C47CB',
                backgroundColor: '#F5F8FF'
              }
            }}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            onClick={onDisconnect}
            sx={{
              backgroundColor: '#DC362E',
              color: '#fff',
              fontWeight: 600,
              fontSize: '14px',
              borderRadius: '80px',
              textTransform: 'none',
              boxShadow: 'none',
              '&:hover': {
                backgroundColor: '#b82a23',
                boxShadow: 'none'
              }
            }}
          >
            Disconnect
          </Button>
        </Box>
      </DialogActions>
    </Dialog>
  )
}
